import { UI_ACTIONS } from 'store/v1/ui/ui.constants';

import { myToastService } from 'v5/services/front/ToastService/ToastService.connected.js';
import mapAlertError from 'v1/helpers/alertErrors';
import { values } from 'lodash';

const closeModal = () => {
  return { type: UI_ACTIONS.CLOSE_MODAL };
};

const openModal = (modalType, data) => {
  return { type: UI_ACTIONS.OPEN_MODAL, modalType, data };
};

const openContactSidebar = selectedContact => {
  return { type: UI_ACTIONS.OPEN_CONTACT_SIDEBAR, selectedContact };
};

const closeContactSidebar = () => {
  return { type: UI_ACTIONS.CLOSE_CONTACT_SIDEBAR };
};

const openProductionSidebar = (selectedProduction, options = {}) => {
  return {
    type: UI_ACTIONS.OPEN_PRODUCTION_SIDEBAR,
    selectedProduction,
    options
  };
};

const closeProductionSidebar = () => {
  return { type: UI_ACTIONS.CLOSE_PRODUCTION_SIDEBAR };
};

const openBookingSidebar = (selectedBooking, options = {}) => {
  return { type: UI_ACTIONS.OPEN_BOOKING_SIDEBAR, selectedBooking, options };
};

const closeBookingSidebar = () => {
  return { type: UI_ACTIONS.CLOSE_BOOKING_SIDEBAR };
};

function normalizeAlertBody(body) {
  if (typeof body === 'string') return mapAlertError(body) || body;
  if (body && body.message) return mapAlertError(body.message) || body.message;
  if (body && body.Message && body.errors) {
    const errs = values(body.errors);
    if (errs && errs.length) return errs[0];
  }
  return 'Sorry something has gone wrong';
}

const displayAlert = (alertType, body, data) => {
  return function () {
    // this is our v1 bridge to v5 toast service
    const message = normalizeAlertBody(body);
    myToastService.open({ type: alertType, message });
  };
};

export {
  closeModal,
  openModal,
  displayAlert,
  openContactSidebar,
  closeContactSidebar,
  openProductionSidebar,
  closeProductionSidebar,
  openBookingSidebar,
  closeBookingSidebar
};
